'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

const HIDDEN_REFRESH_THRESHOLD_MS = 5 * 60 * 1000;

/**
 * Refreshes router data when the tab returns from a long background stay.
 * The refresh round-trips through middleware, so an expired session redirects
 * to /login immediately instead of leaving stale, unresponsive UI.
 */
export function VisibilitySessionRefresh() {
  const router = useRouter();
  const hiddenAtRef = useRef<number | null>(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        hiddenAtRef.current = Date.now();
        return;
      }

      const hiddenAt = hiddenAtRef.current;
      hiddenAtRef.current = null;

      if (hiddenAt !== null && Date.now() - hiddenAt >= HIDDEN_REFRESH_THRESHOLD_MS) {
        router.refresh();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [router]);

  return null;
}
